export default __webpack_public_path__ + "static/hotel-hospitality-d9a78aa1b3a3f8fb422324a2a98e1342.jpg";